import {
  AreaSeriesPartialOptions, CandlestickSeriesPartialOptions,
  ChartOptions,
  DeepPartial, HistogramSeriesPartialOptions,
} from 'lightweight-charts';

export const GraphicHeights = {
  default: 180,
};

export const GraphicTooltipConfigs = {
  width: 152,
  height: 48,
  margin: 15,
};

export enum GraphicTypes {
  Linear = 'linear',
  Histogram = 'histogram',
  Candlestick = 'candlestick',
}

export enum GraphicColors {
  White = '#FFFFFF',
  Yellow = '#F6CC5B',
  Transparent = 'transparent',
  Blue = '#5B61F6',
  BlueTransparent = 'rgba(91, 97, 246, 0.48)',
  Green = '#98C630',
  Red = '#D65252',
}

export const CommonGraphOptions: DeepPartial<ChartOptions> = {
  layout: {
    backgroundColor: GraphicColors.Transparent,
    textColor: GraphicColors.White,
    fontFamily: 'Roboto',
    fontSize: 12,
  },
  rightPriceScale: {
    scaleMargins: {
      top: 0.15,
      bottom: 0,
    },
    borderVisible: true,
    borderColor: GraphicColors.White,
  },
  timeScale: {
    borderVisible: true,
    borderColor: GraphicColors.White,
    fixLeftEdge: true,
    timeVisible: true,
  },
  handleScale: {
    axisPressedMouseMove: false,
  },
  watermark: {
    color: GraphicColors.Transparent,
  },
  grid: {
    horzLines: {
      visible: false,
    },
    vertLines: {
      visible: false,
    },
  },
  crosshair: {
    horzLine: {
      visible: false,
      labelVisible: false,
    },
    vertLine: {
      visible: true,
      style: 0,
      width: 2,
      color: GraphicColors.Yellow,
      labelBackgroundColor: GraphicColors.White,
      labelVisible: false,
    },
  },
};

export const HistogramGraphSeries: HistogramSeriesPartialOptions = {
  priceLineVisible: false,
  color: GraphicColors.Blue,
};

export const LinearGraphSeries: AreaSeriesPartialOptions = {
  lineColor: GraphicColors.Blue,
  topColor: GraphicColors.BlueTransparent,
  bottomColor: GraphicColors.BlueTransparent,
  lineWidth: 2,
  priceLineVisible: false,
  crosshairMarkerRadius: 4,
  crosshairMarkerBorderColor: GraphicColors.Yellow,
  crosshairMarkerBackgroundColor: GraphicColors.Transparent,
};

export const CandleGraphSeries: CandlestickSeriesPartialOptions = {
  upColor: GraphicColors.Green,
  downColor: GraphicColors.Red,
  borderVisible: false,
  wickVisible: false,
};
